//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import { helpers } from "vuelidate/lib/validators";
import { eventBus } from "@/assets/js/appFunc";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";

export default {
    name: "SearchPerspectiveSidebar",
    components: {
        AQList,
        AQSearch,
        AQEmptySearch,
        AQEmptyState,
        AQSkeleton
    },
    props: {
        updatePerspective: {
            type: Number,
            default: 0
        },
        selectCurrentPerspective: {
            type: Object,
            default: () => {}
        },
        currentSelectedPerspectiveId: {
            type: String,
            default: ""
        },
        perspectiveNewList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            searchPerspective: "",
            perspectivesList: [],
            selectedPerspectiveId: "",
            itemTooltipId: "",
            loading: true,
            openSearch: false
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        disableSearchPerspective() {
            return !this.searchPerspective && this.perspectivesList.length < 2;
        }
    },
    watch: {
        updatePerspective(newValue) {
            if (newValue) {
                this.selectedPerspectiveId = "";
                this.notifNoMoreAccess();
                this.getPerspectives();
            }
        },
        currentSelectedPerspective: {
            handler() {
                this.selectedPerspectiveId = "";
                if (this.updatePerspective) {
                    this.getPerspectives();
                }
            },
            immediate: true
        },
        perspectiveNewList: {
            handler(newValue) {
                this.perspectiveDataListMethod(newValue);
            }
        }

    },
    created() {
        const { query, params } = this.$route;
        if (params.dataViewsId) {
            this.selectedPerspectiveId = params.dataViewsId;
        } else {
            const { perspectiveId } = query;
            if (perspectiveId) {
                this.selectedPerspectiveId = perspectiveId;
            }
        }
    },
    mounted() {
        const { selectedId, getData } = this.selectCurrentPerspective || {};
        const { query } = this.$route;
        if (query.search) {
            this.searchPerspective = query.search;
            this.openSearch = true;
            this.$nextTick(() => {
                this.openSearch = false;
            });
        }
        if (getData) {
            this.searchPerspective = "";
            if (selectedId && !this.selectedPerspectiveId) {
                this.selectedPerspectiveId = selectedId;
                this.getPerspectives(null, true);
            } else {
                this.getPerspectives();
            }
            this.$emit("update:selectCurrentPerspective", {});
        }
    },
    activated() {
        const { query } = this.$route;
        if (!query.search && this.searchPerspective) {
            this.searchPerspective = "";
        }
    },
    methods: {
        ...mapActions("perspectiveBuilder", ["actGetCasePerspectives", "actLoadCasePerspectiveData"]),
        ...mapMutations("perspectiveBuilder", ["setPerspectiveId"]),
        searchForPerspectives() {
            if (this.searchPerspective) {
                const searchValue = this.searchPerspective.trim();
                const alphaNumSpaces = helpers.regex("alphaNumSpaces", /^[a-zA-Z0-9\s]*$/i);
                if (searchValue && alphaNumSpaces(searchValue)) {
                    this.getPerspectives(searchValue.replace(/\s+/g, " "));
                } else {
                    this.loading = false;
                    this.perspectivesList = [];
                }
                this.$router.replace({ query: { search: searchValue } });
            } else {
                this.getPerspectives();
                this.$router.replace({ query: {} });
            }
        },
        notifNoMoreAccess() {
            this.$toast.showNotify({
                type: "error",
                message: this.$t("exportReports.noPermission")
            });
        },
        getPerspectives(payload, sameId) {
            this.loading = true;
            this.actGetCasePerspectives(payload).then(({ data }) => {
                if (!payload) {
                    this.$store.commit("perspectiveBuilder/setPerspectivesList", data);
                }

                this.perspectiveDataListMethod(data, payload, sameId);
            });
        },
        perspectiveDataListMethod(data, payload, sameId) {
            this.perspectivesList = data;
            this.loading = false;

            this.$emit("perspectiveList", data);
            if (this.selectedPerspectiveId) {
                this.selectPerspective(this.selectedPerspectiveId, sameId);
            }
        },
        selectPerspective(perspectiveId, sameId) {
            if (!sameId) {
                this.selectedPerspectiveId = perspectiveId;

                this.actLoadCasePerspectiveData(perspectiveId).then(({ data }) => {
                    eventBus.$emit("perspectiveLoaded");
                    this.$store.commit("perspectiveBuilder/setPerspectiveId", perspectiveId);

                    const entity = (this.perspectivesList || []).find(({ id }) => id === perspectiveId);
                    this.$store.commit("perspectiveBuilder/setSearchPerspectiveData", entity || {});

                    let process = {};
                    const { processId: id, processName: name } = data.setup;

                    if (id && name) {
                        process = { id, name, perspectiveId };
                    }

                    this.$emit("perspectiveData", { ...data, process });
                    this.$emit("update:currentSelectedPerspectiveId", perspectiveId);
                })
                    .catch(() => {
                        const entity = (this.perspectivesList || []).find(({ id }) => id === perspectiveId);
                        this.$store.commit("perspectiveBuilder/setSearchPerspectiveData", entity || {});
                        const data = { process: { id: "" }, perspectiveId };
                        this.$emit("perspectiveData", data);
                    });
            }
        }
    }
};
